<template>
  <Modal
    v-model:isOpen="isOpenModel"
    modalId="order-logs-modal"
    title="Logs"
    :subtitle="order ? `Order #${order.id}` : undefined"
    maxWidth="5xl"
    @close="onClose"
  >
    <template #content>
      <OrderLogsArea v-if="order" :logs="order.auditEvents"></OrderLogsArea>
    </template>
  </Modal>
</template>

<script setup lang="ts">
import OrderLogsArea from './OrderLogsArea.vue';
import Modal from '@/components/core/Modal/Modal.vue';

defineProps<{
  order?: any;
}>();

const isOpenModel = defineModel<boolean>('isOpen', { default: false });

const emit = defineEmits<{
  (e: 'close'): void;
}>();

function onClose() {
  emit('close');
}
</script>
